import Vue from "vue";
import router from "./router/index";
import Router from 'vue-router'
const routerReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
return routerReplace .call(this, location).catch(error=> error)
};
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
return routerPush .call(this, location).catch(error=> error)
};
import VueAxios from "vue-axios";
import Vant from "vant";
import "vant/lib/index.css";
// import VueCompile from 'vue-template-compiler'
Vue.use(Vant);

import { Lazyload } from "vant";
Vue.use(Lazyload, {
    error: "/statics/images/nav_e.png",
    loading: "/statics/images/loading.gif",
});

// 各API接口
import api from "./api/api"; // 导入api接口
// 首页模板
import App from "./components/page/App.vue";
// 状态管理
import store from "./vuex/store";
// import VConsole from "vconsole";
// new VConsole();
// VueCompile
// Vue.use(VueCompile)
// 全局参数
// import publicData from './config';
const publicData = {
    errImg: process.env.BASE_URL + "statics/images/nav_e.png", // 图片加载失败图
    loadImg: process.env.BASE_URL + "statics/images/loading.gif", // 图片加载中图片
    uploadImage: "https://sdjyalbum.oss-cn-shanghai.aliyuncs.com/", // 上传图片的url
	iyiqiUrl: "http://uat.rcisyn.com:8800/#/",
    // 生产环境
    clientUrl: "https://mall.shidaijiyi.com", //客户端跳转url
    wsuri: "wss://mall.shidaijiyi.com:9506/", // 正式直播接收信息
    imgPath: "https://mall.shidaijiyi.com/", // 正式
    domain: "https://mall.shidaijiyi.com", // 正式 图片路径  注: 分享时也使用了它,分享图片需要拼全路径
    numberUrl: "https://numberwenlvh5.shidaijiyi.com", // 文旅 支付成功跳回文旅
    richTextImage: "https://admin.shidaijiyi.com/",
	cangpinUrl: "https://numpro.shidaijiyi.com", // 数字藏品
	// 测试环境 
	// clientUrl: "http://11.22.33.20:8081/m",
    // clientUrl: "http://tmall-new.shanmuzhi.com/#",
	// wsuri: "wss://tmall-new.shanmuzhi.com:9601/", // 测试直播接收信息
    // imgPath: "http://timemap.shanmuzhi.com/", // 测试 
    // domain: "http://tmall-new.shanmuzhi.com", // 测试 图片路径
    // numberUrl: "http://yutianwenlv_h5.shanmuzhi.com", // 数字文旅
	// cangpinUrl: "http://numpro.shanmuzhi.com", // 数字藏品 http://localhost:8080/#/ 
    // richTextImage: "http://timemap.shanmuzhi.com/",
    locationDefault: {
        // 默认定位 天津
        // lng: 117.707677, // 117.181961
        // lat: 39.025445, // 39.0824
		lng: 117.181961,
        lat: 39.0824,
    },
    connectTime: 0, // 环信重连次数
    isIMLogout: false,
    miniUserName:'gh_ac3aa3211774',// 微信小程序的username
    intangibleDefault:
        process.env.BASE_URL + "statics/images/default_goods.png", // 商品默认图片
    defaultTouxiang:
        process.env.BASE_URL + "statics/images/default_touxiang.png", // 头像默认图片
    defalutFengmian:
        process.env.BASE_URL + "statics/images/default_fengmian.png", // 封面默认图片
    logo: process.env.BASE_URL + "statics/images/default_touxiang.png",
	headLineTouxiang: process.env.BASE_URL + "statics/images/my/icon_logo.png", // 头条头像
    ossImage: "https://sdjyalbum.oss-cn-shanghai.aliyuncs.com", // OSS 图片路径 
    shareImgPath: "https://admin.shidaijiyi.com/statics/minipic/share/", // 分享图片地址
	shareDefaultIcon: process.env.BASE_URL + "statics/images/logo_red.png", // 分享默认图
	shareDefaultTitleA: '时代记忆', // 分享默认标题A类 
	shareDefaultTitleB: '时代记忆让非遗文化活起来！', // 分享默认标题B类
    webimConfig: {
      xmppURL: '//im-api-v2.easemob.com/ws',    // xmpp Server地址
      apiURL: '//a1.easemob.com',               // rest Server地址
      appkey: '1121200608042432#pvqpdiz6ioq3lnkaujmji742m6ak3cm1',        // App key
      https: false,                            // 是否使用https
      isHttpDNS: false,                          // 3.0 SDK支持，防止DNS劫持从服务端获取XMPPUrl、restUrl 
      isMultiLoginSessions: false,              // 是否开启多页面同步收消息，注意，需要先联系商务开通此功能
      isDebug: true,                           // 打开调试，会自动打印log，在控制台的console中查看log
      autoReconnectNumMax: 2,                   // 断线重连最大次数
      heartBeatWait: 4500,                      // 使用webrtc（视频聊天）时发送心跳包的时间间隔，单位ms
      delivery: true,                           // 是否发送已读回执
    },
    webimUserInfo: null,  // 登录用户 环信信息
    webimconn: {}, // 环信conn
    userInfo: null, // 网站登录用户信息
	getTextMsg: null, // 收到环信信息
	// 距离某个时间点的差  xx天
	intervalTime(currentTimsmap,endTime){
		var subTime = endTime - currentTimsmap
		if(subTime > 0){
			// 相差的天数
			var days = Math.floor(subTime / (24 * 3600 * 1000))
			return days + "天"
		}else{
			return false
		}
	},
	// 匹配手机号,中间四位隐藏
	formatPhone(iphone){
		var reg = /^(\d{3})\d*(\d{4})$/;
		if(reg.test(iphone)){
			return iphone.replace(reg,'$1****$2')
		}else{
			return iphone
		}
		
	},
	// 图片http开头
	withHttpStart(str){
		if(str.indexOf('http') == 0){
			return true
		}else{
			return false
		}
	},
};
Vue.prototype.$publicData = publicData;
Vue.config.productionTip = false;
Vue.prototype.$api = api; // 将api挂载到vue的原型上
// 工具类函数
import util from "./utils/index";
Vue.prototype.$util = util;// 将工具类挂载到vue的原型上
Vue.config.ignoredElements = ['wx-open-launch-weapp']; // 忽略编译自定义元素
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
